/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import { Button, Input, Icon, Select, Modal, SelectActions } from '../../components';
import { Globals, Constants, axios } from '../../utils';
import NumberFormat from 'react-number-format';
import TrashIcon from '../../assets/icons/trash.png';

function parse(value, decimals = 2) {
	const multiplier = Math.pow(10, decimals);
	return parseFloat((Math.round((parseFloat(value || 0) + 0.00000001) * multiplier) / multiplier).toFixed(decimals));
}

class DuplicateOrder extends React.Component {

	state = {
		form: {
			client_id: '',
			method_id: '',
			file: '',
			initial_payment: '',
			status: Constants.PAYMENT_TYPES.PAID,
			discount: '',
			credit_days: '',
			information: '',
			show_taxes: Constants.ORDERS.SHOW_TAXES.NO,
			iva: null,
			iva_bs: null,
			currentFileName: '',
			general_discounts: [],
		},
		total: 0,
		methods: [],
		client: null,
		visible: false,
		order: null,
		visible_product: false,
		visible_dates: false,
		dates: [],
		height: 0,
		methods_selected: [],
		disabled_button: false,
		visible_modal: false,
		seller: null,
		sellers: [],
		clients: [],
		warehouses: [],
		formatWarehouses: [],
		config: null,
		general_discounts: [],
		countryEquivalent: Globals.getUserCountryEquivalent(),
		IVA: Globals.getAdminIva(),
		discountsRules: [],
		appliedDiscountsRules: [],
		totals: {
			subtotal_usd: 0,
			subtotal_bs: 0,
			paid_usd: 0,
			paid_bs: 0,
			left_usd: 0,
			left_bs: 0,
			total_bs: 0,
			total_usd: 0,
			change_bs: 0,
			change_usd: 0,
			total_discount: 0,
			total_discount_percentage: 0,
			original_subtotal_usd: 0
		},
	}

	async componentDidMount() {
		Globals.setLoading();
		const order = this.props.order;

		const discounts = (order?.discounts || [])
			.filter(d => d?.general_discount?.type === 'general')
			.map(d => ({
				discount_id: d.general_discount_id,
				value: parseFloat(d.porcentage) || 0,
			}));

		await this.setState({
			form: {
				...this.state.form,
				client_id: order?.client_id || '',
				method_id: order?.method_id || '',
				status: order?.status_payment ?? Constants.PAYMENT_TYPES.PAID,
				initial_payment: order?.initial_payment || '',
				discount: (() => {
					const principalDiscount = order?.discounts?.find(d => d.general_discount_id === null);
					if (principalDiscount) return parseFloat(principalDiscount.porcentage) || '';
					return order?.discount_percentage || '';
				})(),
				credit_days: order?.credit_days?.toString() || '',
				information: order?.information || '',
				iva: order?.iva,
				iva_bs: order?.iva_bs,
				show_taxes: order?.iva ? Constants.ORDERS.SHOW_TAXES.YES : Constants.ORDERS.SHOW_TAXES.NO,
				currentFileName: '', // Duplicado inicia sin comprobante
				general_discounts: discounts,
			},
			client: order?.client || (this.props.clients || []).find(c => +c.value === +(order?.client_id)) || null,
			seller: order?.seller || null,
			order: {
				...order,
				details: (order?.details || []).filter(i => i.product && !i.product.deleted_at).reduce((acc, curr) => {
					const existingIndex = acc.findIndex(item =>
						item.product_id === curr.product_id &&
						item.size_id === curr.size_id &&
						item.color_id === curr.color_id
					);

					if (existingIndex !== -1) {
						const existing = acc[existingIndex];
						existing.quantity = (parseFloat(existing.quantity) + parseFloat(curr.quantity)).toString();
						existing.original_quantity = existing.quantity;
						existing.initial_qty = existing.quantity;
						existing._merged_from_limit = true;

						const currPrice = parseFloat(curr.price);
						const existingPrice = parseFloat(existing.price);
						if (currPrice > existingPrice) {
							existing.price = curr.price;
							existing.selected_price = curr.price;
							existing._user_selected_price = curr.price;
							existing.initial_price = curr.price;
							existing.original_price = curr.price;
						}
					} else {
						const newItem = { ...curr };
						newItem.discount = newItem.discount_percentage;
						newItem.selected_price = newItem.price;
						newItem._user_selected_price = newItem.price;
						newItem.original_quantity = newItem.quantity;
						newItem.warehouse_id = curr.warehouse_id;
						newItem.subtotal = parseFloat(curr.subtotal) || parse((newItem.selected_price || newItem.price || 0) * (newItem.quantity || 0), 2);

						// Determinar si el descuento guardado es manual o de regla automática.
						const detailDiscounts = curr.discounts || [];
						const manualDetailDiscount = detailDiscounts.find(d => d.discount_id === null);
						const autoDetailDiscounts = detailDiscounts.filter(d => d.discount_id !== null);

						if (manualDetailDiscount) {
							newItem.manual_discount = parseFloat(manualDetailDiscount.porcentage) || 0;
						} else if (autoDetailDiscounts.length > 0) {
							newItem.manual_discount = 0;
						} else {
							const rawDisc = String(newItem.discount_percentage || '0').replace(/%/g, '').trim();
							newItem.manual_discount = parseFloat(rawDisc) || 0;
						}

						if (autoDetailDiscounts.length > 0) {
							newItem.saved_applied_rules = autoDetailDiscounts.map(d => ({
								discount_id: d.discount_id,
								name: d.discount ? d.discount.name : 'Descuento Automático',
								percentage: parseFloat(d.porcentage)
							}));
							newItem.saved_item_percentage = newItem.saved_applied_rules.reduce((sum, r) => sum + r.percentage, 0);
						}

						newItem.initial_qty = newItem.quantity;
						newItem.initial_price = newItem.price;
						acc.push(newItem);
					}
					return acc;
				}, [])
			},
			methods_selected: (order?.payment_methods || []).map(item => ({
				id: item.method_id || item.id,
				amount: item.amount,
				amount_bs: item.amount_bs,
				name: item.method?.name || item.name,
			})),
		});

		await this.getSellers();
		await this.getDiscounts();
		await this.getConfig();
		await this.getWarehouses();
		this.setTotals();
		Globals.quitLoading();
	}

	getSellers = async () => {
		try {
			const filter = {
				user_id: this.props.user.id,
				all: true,
			};
			const res = await axios.post('web/admin/orders/sellers', filter);
			const rawSellers = Array.isArray(res.data) ? res.data : (res.data?.sellers?.data || res.data?.sellers || []);
			if (rawSellers.length > 0) {
				const sellersList = rawSellers.map(seller => ({
					value: seller.id,
					label: seller.name,
					commission: seller.commission,
				}));
				const currentSellerId = this.state.seller?.id || this.state.order?.seller_id;
				const fullSeller = currentSellerId
					? rawSellers.find(s => +s.id === +currentSellerId)
					: null;
				this.setState({
					sellers: sellersList,
					fullSellers: rawSellers,
					...(fullSeller ? { seller: fullSeller } : {}),
				});
			}
		} catch (error) {
			console.log(error);
		}
	}

	getDiscounts = async () => {
		try {
			const res = await axios.post('admin/discounts/get', { user_id: this.props.user.id, all: true, status: Constants.STATUS_ACTIVE });
			const discountsList = Array.isArray(res.data) ? res.data : (Array.isArray(res.data?.discounts) ? res.data.discounts : []);
			const validDiscounts = discountsList.filter(d => d.status === 1 || d.status === Constants.STATUS_ACTIVE);
			this.setState({ discountsRules: validDiscounts });
		} catch (error) {
			console.log('Error fetching discounts:', error);
			this.setState({ discountsRules: [] });
		}
	}

	getConfig = async () => {
		try {
			const { data } = await axios.post("sync/config", { user_id: this.props.user.id });
			if (data) {
				this.setState({ config: data.config || data });
			}
		} catch (error) {
			console.log(error);
		}
	}

	getWarehouses = async () => {
		try {
			const data = {
				web: true,
				user_id: this.props.user.id,
				is_select: true,
				warehouse_id: this.props.user.level_id == Constants.ROLE_ADMIN ? null : this.props.user.warehouse_id,
				without_products: true,
				unique_by_size_color: true,
			};
			const res = await axios.post('web/admin/warehouses', data);
			const rawWarehouses = res.data?.warehouses || (Array.isArray(res.data) ? res.data : []);
			if (rawWarehouses.length > 0) {
				const formatWarehouses = rawWarehouses.map(warehouse => ({
					value: warehouse.id,
					label: warehouse.name
				}));

				const mainIdx = formatWarehouses.findIndex(x => x.value === this.props.user.warehouse_principal);
				if (mainIdx >= 0) {
					const main = formatWarehouses[mainIdx];
					formatWarehouses.splice(mainIdx, 1);
					formatWarehouses.unshift(main);
				}

				this.setState({
					warehouses: rawWarehouses,
					formatWarehouses
				});
			}
		} catch (error) {
			console.log('DuplicateOrder -> getWarehouses -> catch: ', error);
		}
	}

	getDecimals = () => {
		if (this.state.config && this.state.config.three_decimals === 1) return 3;
		return 2;
	}

	enableSubmit = () => {
		return this.setState({
			disabled_button: false
		});
	}

	getTotal = () => {
		let total = this.state.totals?.total_usd || 0;
		if (this.state.form.show_taxes == Constants.ORDERS.SHOW_TAXES.YES) {
			const iva = this.getIva();
			total += Number(iva);
		}
		return parse(total, this.getDecimals());
	}

	getDiscount = () => {
		return parse(this.state.totals?.total_discount || 0, this.getDecimals());
	}

	getProductDiscounts = () => {
		return 0; // Calculado en setTotals
	}

	getSubtotal = () => {
		return parse(this.state.totals?.subtotal_usd || 0, this.getDecimals());
	}

	getIva = () => {
		const IVA = this.state.IVA;
		let iva = 0;
		const decimals = this.getDecimals();

		const totals = this.state.totals || {};
		const subtotal_usd = totals.subtotal_usd || 0;
		const total_usd = totals.total_usd || 0;

		const globalDiscountRatio = subtotal_usd > 0 ? (total_usd / subtotal_usd) : 1;

		this.state.order?.details?.forEach((i) => {
			let product_iva = 0;
			const productData = i.product || i;
			if (!!this.state.form.show_taxes && (productData.exento == Constants.PRODUCT_EXENTO.NO)) {
				const discountedSubtotal = (i.subtotal || 0) * globalDiscountRatio;
				product_iva = parse((discountedSubtotal * IVA) / 100, decimals);
			}
			iva += product_iva;
		});

		return parse(iva, decimals);
	}

	getProductIva = (product) => {
		const IVA = this.state.IVA;
		let iva = 0;
		const decimals = this.getDecimals();

		const totals = this.state.totals || {};
		const subtotal_usd = totals.subtotal_usd || 0;
		const total_usd = totals.total_usd || 0;
		const globalDiscountRatio = subtotal_usd > 0 ? (total_usd / subtotal_usd) : 1;

		const filteredDetails = this.state.order?.details?.filter(detail => (detail.product?.id || detail.product_id) === (product.id || product.product_id));
		filteredDetails?.forEach(i => {
			let product_iva = 0;
			const productData = i.product || i;
			if (!!this.state.form.show_taxes && (productData.exento == Constants.PRODUCT_EXENTO.NO)) {
				const discountedSubtotal = (i.subtotal || 0) * globalDiscountRatio;
				product_iva = parse((discountedSubtotal * IVA) / 100, decimals);
			}
			iva += product_iva;
		});

		return iva;
	}

	getIvaBs = () => {
		const conversion = this.state.order?.conversion || 1;
		let iva_bs = (this.getIva() || 0) * conversion;
		return parse(iva_bs, this.getDecimals());
	}

	applyProductDiscount = (subtotal, discountStr, decimals) => {
		if (discountStr == null || discountStr === '' || subtotal <= 0) return subtotal;

		const raw = String(discountStr).replace(/%/g, '').trim().replace(/,/g, '.');
		let result = subtotal;

		if (raw.includes('/') || raw.includes('+')) {
			const parts = raw.split(/[/+]/);
			parts.forEach(part => {
				const pct = parseFloat(part.trim());
				if (!isNaN(pct) && pct > 0) {
					const d = pct > 100 ? 100 : pct;
					result -= result * (d / 100);
				}
			});
		} else {
			const pct = parseFloat(raw);
			if (!isNaN(pct) && pct > 0) {
				const d = pct > 100 ? 100 : pct;
				result -= result * (d / 100);
			}
		}

		return result < 0 ? 0 : result;
	}

	setTotals = async () => {
		const { form, order, discountsRules } = this.state;
		if (!order || !order.details) return;
		const exchangeRate = order?.conversion || 1;
		const decimals = this.getDecimals();

		let subtotal_usd = 0;
		let original_subtotal_usd = 0;
		let totalDiscountAmount = 0;

		const products = [...order.details];
		const paid_usd = (this.state.methods_selected || []).reduce((acc, curr) => acc + Number(curr.amount || 0), 0);
		const paid_bs = parse(paid_usd * exchangeRate, decimals);

		const isOdooUser = this.props.user && ((this.props.user.admin ? this.props.user.admin.odoo : this.props.user.odoo) == 1);
		const checkIsBultoCajaCestaUnidad = (prod) => Globals.checkIsBultoCajaCestaUnidad(prod, isOdooUser);
		// Volumen: solo bultos/cajas/cestas (excluye "Unidad")
		const checkIsBultoCajaCesta = (prod) => Globals.checkIsBultoCajaCesta(prod, isOdooUser);

		// ---------------------------------------------------------
		// 1. RECOPILAR DESCUENTOS GLOBALES (General y Pronto Pago)
		// ---------------------------------------------------------
		let new_general_discounts = [];

		if (discountsRules && discountsRules.length > 0) {
			discountsRules.forEach(master => {
				if (master.status !== 1) return;

				// A. Descuento General (Ahora es controlado por el usuario)
				if (master.type === 'general') {
					const userDiscount = form.general_discounts.find(d => d.discount_id === master.id);
					if (userDiscount && userDiscount.value !== '') {
						new_general_discounts.push({
							discount_id: master.id,
							value: userDiscount.value
						});
					}
				}

				// B. Pronto Pago
				if (master.type === 'pronto_pago' && form.status == Constants.PAYMENT_TYPES.TO_PAY && (this.state.client || form.client_id) && form.credit_days) {
					const days = parseInt(form.credit_days);
					const clientId = this.state.client?.id || this.state.client?.value || form.client_id;
					if (!isNaN(days) && days > 0 && clientId) {
						master.discount_details.forEach(rule => {
							if (rule.client_id == clientId && days <= rule.max_days) {
								new_general_discounts.push({ discount_id: master.id, value: parseFloat(rule.percentage) });
							}
						});
					}
				}
			});
		}

		const cartProductIds = products.map(item => item.product_id || item.id);
		const hasAnyOrderEdit = !!this.state.orderModified || products.some(p => p._edited);

		// ---------------------------------------------------------
		// 2. CÁLCULO LÍNEA POR LÍNEA
		// ---------------------------------------------------------
		for (const product of products) {
			const qty = (product?.decimal_stock ?? product.product?.decimal_stock) == Constants.DECIMAL_STOCK.YES ? parseFloat(product.quantity) : parseInt(product.quantity);

			let originalPrice = parseFloat(product.original_price || product.sale_price || product.price);
			if (product._user_selected_price !== undefined) {
				originalPrice = parseFloat(product._user_selected_price);
			}

			let appliedPrice = originalPrice;
			let itemPercentageDiscount = 0;
			let applied_rules = [];

			const productData = product.product || product;
			let defaultPriceToCompare = productData.default_price_value;

			if (productData.type === Constants.PRODUCTS_TYPE.SIZE_COLOR && productData.size_colors) {
				const size_color = productData.size_colors.find(i =>
					(product.size_id && product.color_id && i.size_id === product.size_id && i.color_id === product.color_id) ||
					(product.size_id && !product.color_id && i.size_id === product.size_id && !i.color_id) ||
					(product.color_id && !product.size_id && i.color_id === product.color_id && !i.size_id)
				);
				if (size_color && size_color.sale_price != null) {
					defaultPriceToCompare = size_color.sale_price;
				}
			}
			product.special_price_applied = false;
			product.special_price_limit = null;

			const limitMaster = (discountsRules || []).find(m =>
				m.status === 1 &&
				m.type === 'limite_cantidad' &&
				m.discount_details?.some(r => r.product_id === (product.product_id || product.id))
			);
			const limitRule = limitMaster?.discount_details?.find(r => r.product_id === (product.product_id || product.id));

			if (limitRule && defaultPriceToCompare != null && !product._user_changed_price && parseFloat(originalPrice) === parseFloat(limitRule.special_price)) {
				originalPrice = parseFloat(defaultPriceToCompare);
				appliedPrice = originalPrice;
			}

			const isDefaultPrice = defaultPriceToCompare == null || parseFloat(originalPrice) === parseFloat(defaultPriceToCompare);
			const isUnmodified = product.initial_qty !== undefined &&
				parseFloat(qty) === parseFloat(product.initial_qty) &&
				(parseFloat(originalPrice) === parseFloat(product.initial_price) || (limitRule && parseFloat(product.initial_price) === parseFloat(limitRule.special_price)));

			if (isDefaultPrice && limitRule) {
				if (qty <= limitRule.max_quantity) {
					appliedPrice = parseFloat(limitRule.special_price);
					product.special_price_applied = true;
					product.special_price = appliedPrice;
					product.original_special_price = appliedPrice;
					product.original_price = originalPrice;
					product.special_price_limit = null;
				} else if (limitRule.max_quantity && qty > limitRule.max_quantity) {
					const specialQty = parseFloat(limitRule.max_quantity);
					const regularQty = qty - specialQty;
					appliedPrice = ((specialQty * parseFloat(limitRule.special_price)) + (regularQty * originalPrice)) / qty;
					product.special_price_applied = true;
					product.special_price = parse(appliedPrice, decimals);
					product.original_special_price = parseFloat(limitRule.special_price);
					product.original_price = originalPrice;
					product.special_price_limit = specialQty;
				}
			}

			// EVALUAR REGLAS POR PRODUCTO
			if (!hasAnyOrderEdit && isUnmodified && product.saved_applied_rules) {
				applied_rules = [...product.saved_applied_rules];
				itemPercentageDiscount = product.saved_item_percentage;
			} else if (discountsRules && discountsRules.length > 0 && isDefaultPrice) {
				discountsRules.forEach(master => {
					if (master.status !== 1) return;

					let rutaVendedorApplied = false;
					let applicableVolumenRules = [];

					master.discount_details.forEach(rule => {

						// Por Volumen
						if (master.type === 'volumen') {
							if ((rule.product_id === (product.product_id || product.id) || (rule.category_id && rule.category_id === (product.category_id || productData?.category_id))) && qty >= rule.min_quantity) {
								applicableVolumenRules.push(rule);
							}
						}

						// Por Ruta / Vendedor
						if (master.type === 'ruta_vendedor' && rule.product_id === (product.product_id || product.id) && !rutaVendedorApplied) {
							const activeSeller = this.state.seller || this.props.user;
							const sellerId = activeSeller ? activeSeller.id || activeSeller.value : null;
							let isInZone = false;
							if (rule.zone_id && activeSeller) {
								if (activeSeller.zones && activeSeller.zones.length > 0) {
									isInZone = activeSeller.zones.some(z => z.id == rule.zone_id || z.zone_id == rule.zone_id);
								} else if (activeSeller.zone_id == rule.zone_id) {
									isInZone = true;
								}
							}

							if (isInZone || (rule.seller_id && rule.seller_id == sellerId)) {
								itemPercentageDiscount += parseFloat(rule.percentage);
								applied_rules.push({ discount_id: master.id, name: master.name, percentage: parseFloat(rule.percentage) });
								rutaVendedorApplied = true;
							}
						}

						// Por Surtido
						if (master.type === 'surtido' && rule.product_id === (product.product_id || product.id)) {
							let distinctCount = 0;
							master.discount_details.forEach(surtidoRule => {
								if (surtidoRule.counts_for_calculation && cartProductIds.includes(surtidoRule.product_id)) distinctCount++;
							});

							if (distinctCount >= rule.min_quantity) {
								itemPercentageDiscount += parseFloat(rule.percentage);
								applied_rules.push({ discount_id: master.id, name: master.name, percentage: parseFloat(rule.percentage) });
							}
						}

						// Por Surtido y Volumen
						if (master.type === 'surtido_volumen' && (rule.product_id === (product.product_id || product.id) || (rule.category_id && rule.category_id === (product.category_id || productData?.category_id)))) {
							const isProductBulto = checkIsBultoCajaCestaUnidad(product);
							if (isProductBulto) {
								let participatingCartProdIds = [];
								let totalBultos = 0;

								products.forEach(cartProd => {
									const isCartProdBulto = checkIsBultoCajaCestaUnidad(cartProd);
									const isParticipating = master.discount_details.some(svRule =>
										(svRule.product_id === (cartProd.product_id || cartProd.id) || (svRule.category_id && svRule.category_id === (cartProd.category_id || cartProd.product?.category_id)))
										&& svRule.counts_for_calculation
									);
									if (isParticipating && isCartProdBulto) {
										// Surtido (SKU distintos): incluye "Unidad"
										const actualCartProdId = cartProd.product_id || cartProd.id;
										if (!participatingCartProdIds.includes(actualCartProdId)) {
											participatingCartProdIds.push(actualCartProdId);
										}
									}
									if (isParticipating && checkIsBultoCajaCesta(cartProd)) {
										// Volumen (total bultos/cajas/cestas): NO incluye "Unidad"
										const cDecStock = cartProd.decimal_stock ?? cartProd.product?.decimal_stock;
										const qtyProd = cDecStock == 1 || cDecStock == '1' || cDecStock == true ? parseFloat(cartProd.quantity) : parseInt(cartProd.quantity);
										totalBultos += qtyProd;
									}
								});

								let distinctCount = participatingCartProdIds.length;
								const meetsSku = distinctCount >= rule.min_sku;
								const meetsBultos = totalBultos >= rule.min_bultos;

								if (meetsSku && meetsBultos) {
									const pctOne = parseFloat(rule.percentage_one_condition);
									const pctBoth = parseFloat(rule.percentage_both_conditions);
									if (meetsSku !== meetsBultos)
									if (!isNaN(pctOne) && pctOne > 0 && !applied_rules.some(r => r.discount_id === master.id)) {
										itemPercentageDiscount += pctOne;
										applied_rules.push({ discount_id: master.id, name: master.name, percentage: pctOne });
									}
									if (!isNaN(pctBoth) && pctBoth > 0 && !applied_rules.some(r => r.discount_id === master.id)) {
										itemPercentageDiscount += pctBoth;
										applied_rules.push({ discount_id: master.id, name: master.name, percentage: pctBoth });
									}
								} else if (meetsSku || meetsBultos) {
									const pctOne = parseFloat(rule.percentage_one_condition);
									if (!isNaN(pctOne) && pctOne > 0 && !applied_rules.some(r => r.discount_id === master.id)) {
										itemPercentageDiscount += pctOne;
										applied_rules.push({ discount_id: master.id, name: master.name, percentage: pctOne });
									}
								}
							}
						}
					});

					if (master.type === 'volumen' && applicableVolumenRules.length > 0) {
						const categoryRules = applicableVolumenRules.filter(r => r.category_id && r.category_id === (product.category_id || productData?.category_id));
						const rulesToApply = categoryRules.length > 0 ? categoryRules : applicableVolumenRules;

						rulesToApply.forEach(rule => {
							itemPercentageDiscount += parseFloat(rule.percentage);
							applied_rules.push({ discount_id: master.id, name: master.name, percentage: parseFloat(rule.percentage) });
						});
					}
				});
			}

			if (itemPercentageDiscount > 100) itemPercentageDiscount = 100;

			if (product.manual_discount === undefined) {
				const rawStr = String(product.discount_percentage || product.discount || '0').trim();
				const discountStr = rawStr.replace(/%/g, '').trim();
				if (discountStr.includes('/')) {
					product.manual_discount = parseFloat(discountStr.split('/')[0]) || 0;
				} else if (discountStr.includes('+')) {
					product.manual_discount = parseFloat(discountStr.split('+')[0]) || 0;
				} else {
					product.manual_discount = parseFloat(discountStr) || 0;
				}
			}

			// Aplicar descuentos en cascada sobre el precio aplicado
			let finalUnitPrice = appliedPrice;

			// 1. Aplicar descuento manual si existe
			if (product.manual_discount > 0) {
				let manualDesc = parseFloat(product.manual_discount);
				if (manualDesc > 100) manualDesc = 100;
				finalUnitPrice -= (finalUnitPrice * (manualDesc / 100));
			}

			// 2. Aplicar descuento automático de reglas en cascada (volumen, ruta, surtido_volumen, etc.)
			if (applied_rules.length > 0) {
				applied_rules.forEach(ar => {
					let ruleDesc = parseFloat(ar.percentage);
					if (!isNaN(ruleDesc) && ruleDesc > 0) {
						if (ruleDesc > 100) ruleDesc = 100;
						finalUnitPrice -= (finalUnitPrice * (ruleDesc / 100));
					}
				});
			}

			if (finalUnitPrice < 0) finalUnitPrice = 0;

			product.selected_price = appliedPrice;

			// Mostrar visualmente los descuentos aplicados
			const autoDiscountStr = applied_rules.map(r => `${r.percentage}%`).join(' / ');
			if (product.manual_discount > 0 && applied_rules.length > 0) {
				product.discount = `${product.manual_discount}% / ${autoDiscountStr}`;
			} else if (product.manual_discount > 0) {
				if (parseFloat(String(product.discount).replace(/,/g, '.')) !== product.manual_discount) {
					product.discount = product.manual_discount;
				}
			} else if (applied_rules.length > 1) {
				product.discount = autoDiscountStr;
			} else if (applied_rules.length === 1) {
				product.discount = applied_rules[0].percentage;
			} else {
				if (parseFloat(String(product.discount).replace(/,/g, '.')) !== 0) {
					product.discount = '';
				}
			}

			product.applied_discounts = applied_rules;

			const lineOriginalSubtotal = qty * appliedPrice;
			const lineFinalSubtotal = qty * finalUnitPrice;

			product.subtotal = parse(lineFinalSubtotal, decimals);
			original_subtotal_usd += parse(lineOriginalSubtotal, decimals);
			subtotal_usd += product.subtotal;
		}

		// ---------------------------------------------------------
		// 3. APLICAR DESCUENTOS GLOBALES AL TOTAL (CORREGIDO A CASCADA)
		// ---------------------------------------------------------
		let currentSubtotal = subtotal_usd;

		if (form.discount > 0) {
			let desc = parseFloat(form.discount);
			if (desc > 100) desc = 100;
			currentSubtotal -= (currentSubtotal * (desc / 100));
		}

		new_general_discounts.forEach(gd => {
			let desc = parseFloat(gd.value);
			if (desc > 100) desc = 100;
			currentSubtotal -= (currentSubtotal * (desc / 100));
		});

		if (currentSubtotal < 0) currentSubtotal = 0;

		totalDiscountAmount = subtotal_usd - currentSubtotal;

		// ---------------------------------------------------------
		// 4. TOTALES FINALES
		// ---------------------------------------------------------
		const subtotal_bs = parse(subtotal_usd * exchangeRate, decimals);
		const total_usd = parse(currentSubtotal, decimals);
		const total_bs = parse(total_usd * exchangeRate, decimals);
		let left_usd = parse(total_usd - paid_usd, decimals);
		let left_bs = parse(left_usd * exchangeRate, decimals);
		let change_usd = 0;
		let change_bs = 0;

		if (left_usd < 0) {
			change_usd = parse(left_usd * -1, decimals);
			change_bs = parse(change_usd * exchangeRate, decimals);
			left_usd = parse(0, decimals);
			left_bs = parse(0, decimals);
		}

		const totalDiscountPercentage = totalDiscountAmount > 0 ? (totalDiscountAmount / original_subtotal_usd) * 100 : 0;

		const appliedDiscountsRulesMap = {};
		products.forEach(item => {
			const productData = item.product || item;
			if (!item.applied_discounts || item.applied_discounts.length === 0) return;
			const qty = productData?.decimal_stock == Constants.DECIMAL_STOCK.YES ? parseFloat(item.quantity) : parseInt(item.quantity);
			const basePrice = parseFloat(item.selected_price || item.original_price || item.sale_price || item.price || productData.sale_price || productData.price);
			let runningSubtotal = qty * basePrice;
			if (item.manual_discount > 0) {
				const manualDesc = parseFloat(item.manual_discount) > 100 ? 100 : parseFloat(item.manual_discount);
				runningSubtotal -= runningSubtotal * (manualDesc / 100);
			}

			item.applied_discounts.forEach(ad => {
				const mapKey = `${ad.discount_id}_${ad.percentage}`;
				if (!appliedDiscountsRulesMap[mapKey]) {
					appliedDiscountsRulesMap[mapKey] = {
						id: ad.discount_id,
						name: ad.name,
						percentage: parseFloat(ad.percentage),
						totalAmount: 0,
					};
				}
				const pct = parseFloat(ad.percentage) > 100 ? 100 : parseFloat(ad.percentage);
				const ruleAmount = runningSubtotal * (pct / 100);
				runningSubtotal -= ruleAmount;
				appliedDiscountsRulesMap[mapKey].totalAmount = parse(
					appliedDiscountsRulesMap[mapKey].totalAmount + parse(ruleAmount, decimals), decimals
				);
			});
		});

		const appliedDiscountsGeneral = [];
		const allGlobalDiscounts = [];
		if (form.discount > 0) {
			allGlobalDiscounts.push({ discount_id: null, value: parseFloat(form.discount) });
		}
		new_general_discounts.forEach(gd => {
			allGlobalDiscounts.push(gd);
		});

		allGlobalDiscounts.forEach(gd => {
			const masterInfo = discountsRules?.find(r => r.id === gd.discount_id);
			appliedDiscountsGeneral.push({
				id: gd.discount_id,
				name: gd.discount_id == null ? 'Descuento' : masterInfo?.name || 'Descuento General',
				percentage: parseFloat(gd.value),
				totalAmount: 0,
			});
		});

		if (appliedDiscountsGeneral.length > 0) {
			let cascadeSubtotal = subtotal_usd;
			appliedDiscountsGeneral.forEach(gd => {
				let desc = parseFloat(gd.percentage);
				if (desc > 100) desc = 100;
				const discountAmount = cascadeSubtotal * (desc / 100);
				gd.totalAmount = parse(discountAmount, decimals);
				cascadeSubtotal -= discountAmount;
			});
		}

		const appliedDiscountsRules = Object.values(appliedDiscountsRulesMap).concat(appliedDiscountsGeneral);

		await this.setState({
			order: {
				...order,
				details: products
			},
			form: {
				...form,
				change: change_usd,
				general_discounts: new_general_discounts
			},
			appliedDiscountsRules,
			totals: {
				subtotal_usd, subtotal_bs, paid_usd, paid_bs, left_usd, left_bs, total_bs, total_usd, change_bs, change_usd,
				total_discount: parse(totalDiscountAmount, decimals),
				total_discount_percentage: parse(totalDiscountPercentage, decimals),
				original_subtotal_usd: parse(original_subtotal_usd, decimals),
			},
			total: total_usd,
		});
	}

	change = (value, name) => {
		this.setState({
			form: {
				...this.state.form,
				[name]: value
			}
		}, () => {
			if (name === 'show_taxes' || name === 'credit_days' || name === 'client_id' || name === 'initial_payment') this.setTotals();
		});
	}

	setPaymentType = (type) => {
		this.setState({
			form: {
				...this.state.form,
				status: type
			}
		}, () => this.setTotals());
	}
	_unusedSetPaymentType = (type) => {
		this.setState({
			form: {
				...this.state.form,
				status: type
			}
		});
	}

	checkedChange = (checked) => {
		this.setState({
			form: {
				...this.state.form,
				show_taxes: checked ? Constants.ORDERS.SHOW_TAXES.YES : Constants.ORDERS.SHOW_TAXES.NO
			}
		}, () => this.setTotals());
	}

	changeValue = (value, target, index, callback = () => { }) => {
		this.setState(state => {
			const details = [...state.order.details];
			details[index][target] = value;
			details[index]._edited = true;
			if (target === 'discount') {
				const rawDisc = String(value || '0').replace(/%/g, '').trim().replace(/,/g, '.');
				if (rawDisc.includes('/')) {
					details[index].manual_discount = parseFloat(rawDisc.split('/')[0]) || 0;
				} else if (rawDisc.includes('+')) {
					details[index].manual_discount = parseFloat(rawDisc.split('+')[0]) || 0;
				} else {
					details[index].manual_discount = parseFloat(rawDisc) || 0;
				}
			}
			if (target === 'selected_price') {
				details[index]._user_selected_price = value;
				details[index]._user_changed_price = true;
			}
			return {
				order: {
					...state.order,
					details
				}
			};
		}, () => { callback(); this.setTotals(); });
	}

	changeManual = (index, value) => {
		const details = [...this.state.order.details];
		details[index].quantity = value;
		details[index]._edited = true;
		this.setState({
			order: {
				...this.state.order,
				details
			}
		}, () => this.setTotals());
	}

	add = (index, item) => {
		const details = [...this.state.order.details];
		details[index].quantity = (parseFloat(details[index].quantity || 0) + 1).toString();
		details[index]._edited = true;
		this.setState({
			order: {
				...this.state.order,
				details
			}
		}, () => this.setTotals());
	}

	remove = (index, product) => {
		const details = [...this.state.order.details];
		const current = parseFloat(details[index].quantity || 0);
		if (current > 1) {
			details[index].quantity = (current - 1).toString();
			details[index]._edited = true;
			this.setState({
				order: {
					...this.state.order,
					details
				}
			}, () => this.setTotals());
		}
	}

	delete = (index) => {
		const details = [...this.state.order.details];
		details.splice(index, 1);
		this.setState({ orderModified: true });
		this.setState({
			order: {
				...this.state.order,
				details
			}
		}, () => this.setTotals());
	}

	addProduct = () => {
		this.setState({ visible_product: true });
	}

	onCloseProduct = (selectedProducts) => {
		if (selectedProducts && selectedProducts.length > 0) {
			const currentDetails = [...(this.state.order?.details || [])];
			selectedProducts.forEach(prod => {
				const existing = currentDetails.find(d => d.product_id === prod.id);
				if (existing) {
					existing.quantity = (parseFloat(existing.quantity || 0) + 1).toString();
					existing._edited = true;
				} else {
					currentDetails.push({
						...prod,
						product: prod,
						_edited: true,
						product_id: prod.id,
						price: prod.sale_price,
						selected_price: prod.sale_price,
						_user_selected_price: prod.sale_price,
						quantity: '1',
						discount: '0',
						discount_percentage: '0',
						manual_discount: 0,
						warehouse_id: prod.warehouse_id,
					});
				}
			});
			this.setState({
				order: {
					...this.state.order,
					details: currentDetails
				},
				visible_product: false
			}, () => this.setTotals());
		} else {
			this.setState({ visible_product: false });
		}
	}

	addPaymentMethod = (methodId) => {
		const method = (this.props.methods || []).find(m => m.value == methodId);
		if (!method) return;
		const methods_selected = [...this.state.methods_selected];
		if (!methods_selected.some(m => m.id == methodId)) {
			methods_selected.push({
				id: methodId,
				name: method.label,
				amount: ''
			});
			this.setState({ methods_selected }, () => this.setTotals());
		}
	}

	removePaymentMethod = (index) => {
		const methods_selected = [...this.state.methods_selected];
		methods_selected.splice(index, 1);
		this.setState({ methods_selected }, () => this.setTotals());
	}

	changeMethodAmount = (val, index) => {
		const methods_selected = [...this.state.methods_selected];
		methods_selected[index].amount = val;
		this.setState({ methods_selected }, () => this.setTotals());
	}

	changeGeneralDiscount = async (discountId, val) => {
		const list = [...(this.state.form.general_discounts || [])];
		const idx = list.findIndex(d => d.discount_id === discountId);
		if (idx >= 0) {
			list[idx].value = val;
		} else {
			list.push({ discount_id: discountId, value: val });
		}
		await this.setState({
			form: {
				...this.state.form,
				general_discounts: list
			}
		});
		this.setTotals();
	}

	submit = async () => {
		this.setState({ disabled_button: true });

		if (!this.state.order?.details || this.state.order.details.length === 0) {
			Globals.showError("Debe agregar al menos un producto al pedido");
			this.enableSubmit();
			return;
		}

		if (!this.state.form.client_id) {
			Globals.showError("Debe seleccionar un cliente");
			this.enableSubmit();
			return;
		}

		if (this.state.form.status === Constants.PAYMENT_TYPES.TO_PAY && (!this.state.form.credit_days || this.state.form.credit_days <= 0)) {
			Globals.showError("Debe ingresar los días de crédito");
			this.enableSubmit();
			return;
		}

		if (this.state.order.details.filter(i => !i.quantity || i.quantity == 0).length > 0) {
			Globals.showError("Debe seleccionar la cantidad de todos los productos");
			this.enableSubmit();
			return;
		}

		if (this.state.order.details.filter(i => !i.selected_price).length > 0) {
			Globals.showError("Debe seleccionar el precio de todos los productos");
			this.enableSubmit();
			return;
		}

		if (this.state.form.status == Constants.PAYMENT_TYPES.TO_PAY) {
			const total = this.getTotal();
			const sumOfMethods = this.state.methods_selected.map(i => i.amount).reduce((a, b) => parseFloat(a || 0) + parseFloat(b || 0), 0);

			if (sumOfMethods > this.state.form.initial_payment) {
				Globals.showError("El pago inicial debe ser igual a la suma de los métodos de pago.");
				this.enableSubmit();
				return;
			}

			if (this.state.form.initial_payment >= total) {
				Globals.showError("El pago inicial no puede ser igual o mayor al monto total. Este es un pedido por cobrar");
				this.enableSubmit();
				return;
			}

			if (sumOfMethods >= total) {
				Globals.showError("La suma de los métodos de pago no puede ser igual o mayor al monto total. Este es un pedido por cobrar");
				this.enableSubmit();
				return;
			}
		}

		if (this.state.form.discount != '' && this.state.form.discount > 100) {
			Globals.showError("El porcentaje de descuento general no puede ser mayor a 100%");
			this.enableSubmit();
			return;
		}

		// --- Validación de montos con decimales dinámicos ---
		if (this.state.form.status != Constants.PAYMENT_TYPES.TO_PAY || this.state.form.initial_payment != '') {
			if (this.state.methods_selected.length == 0) {
				Globals.showError("Debe seleccionar al menos 1 método de pago");
				this.enableSubmit();
				return;
			}

			if (this.state.methods_selected.filter(i => !i.amount).length > 0) {
				Globals.showError("Debe ingresar el monto de cada método de pago");
				this.enableSubmit();
				return;
			}

			let total = this.getTotal();
			let message = "La suma de los métodos de pago deben ser igual al total";

			if (this.state.form.status == Constants.PAYMENT_TYPES.TO_PAY) {
				total = this.state.form.initial_payment;
				message = "La suma de los métodos de pago deben ser igual al pago inicial";
			}

			const decimals = this.getDecimals(); // Obtenemos 2 o 3 según configuración
			const tolerance = 0.0001;

			// Sumamos los métodos de pago
			const sumOfMethods = this.state.methods_selected.map(i => i.amount).reduce((a, b) => parseFloat(a || 0) + parseFloat(b || 0), 0);

			// Redondeamos AMBOS valores a la cantidad de decimales configurada (ej. 3) antes de comparar
			const roundedSum = parse(sumOfMethods, decimals);
			const roundedTotal = parse(total, decimals);

			if (Math.abs(roundedSum - roundedTotal) > tolerance) {
				console.log('Error validación montos:');
				console.log('Sum:', roundedSum, 'Total:', roundedTotal, 'Diff:', Math.abs(roundedSum - roundedTotal));

				Globals.showError(message);
				this.enableSubmit();
				return;
			}
		}

		Globals.setLoading();

		const expandedDetails = [];
		for (const item of this.state.order.details) {
			if (
				item.special_price_applied &&
				item.special_price_limit != null &&
				item.special_price_limit > 0
			) {
				const decimals = this.getDecimals();
				const qty = item.decimal_stock == Constants.DECIMAL_STOCK.YES
					? parseFloat(item.quantity)
					: parseInt(item.quantity);
				const specialQty = parseFloat(item.special_price_limit);
				const regularQty = qty - specialQty;

				const originalPrice = parseFloat(item.original_price || item.sale_price || item.price);
				const specialPrice = parseFloat(item.original_special_price || item.special_price_limit_price || 0) || null;

				// Fila 1: unidades al precio especial
				expandedDetails.push({
					...item,
					quantity: specialQty,
					selected_price: specialPrice || item.selected_price,
					sale_price: specialPrice || item.sale_price,
					subtotal: parseFloat((specialQty * (specialPrice || item.selected_price)).toFixed(decimals)),
					special_price_applied: true,
					special_price_limit: null,
				});

				// Fila 2: unidades al precio normal (solo si queda cantidad restante)
				if (regularQty > 0) {
					expandedDetails.push({
						...item,
						quantity: regularQty,
						selected_price: originalPrice,
						sale_price: originalPrice,
						subtotal: parseFloat((regularQty * originalPrice).toFixed(decimals)),
						special_price_applied: false,
						special_price_limit: null,
					});
				}
			} else {
				expandedDetails.push(item);
			}
		}

		const data = {
			...this.state.form,
			seller_id: this.state.seller?.id || this.state.seller?.value || this.state.order?.seller_id || this.props.user.id,
			hasFile: true,
			details: JSON.stringify(expandedDetails),
			currency: this.props.currency,
			original_order_id: this.state.order.id,
			user_id: this.props.user?.id,
			methods_selected: JSON.stringify(this.state.methods_selected),
			general_discounts: JSON.stringify(this.state.form.general_discounts),
			iva: this.state.form.show_taxes === Constants.ORDERS.SHOW_TAXES.YES ? this.getIva() : null,
			iva_bs: this.state.form.show_taxes === Constants.ORDERS.SHOW_TAXES.YES ? this.getIvaBs() : null,
			onError: () => {
				this.enableSubmit();
			}
		};

		console.log('data: ', data);

		try {
			const res = await axios.upload('admin/orders/duplicate', data);

			if (res.data?.result === false) {
				Globals.showError(res.data?.error ?? 'El cliente ya ha alcanzado su límite de crédito permitido');
				Globals.quitLoading();
				this.enableSubmit();
				return;
			}

			Globals.showSuccess("Se ha duplicado el pedido correctamente");
			this.props.onClose(true);
		} catch (error) {
			this.enableSubmit();
			console.log(error);
			Globals.showError(error?.response?.data?.error || 'Ocurrió un error al duplicar el pedido');
		}

		Globals.quitLoading();
	}

	render() {
		const { order, visible_product } = this.state;
		const originalOrder = this.props.order;
		const can_include_taxes = Globals.canIncludeTaxes(this.props.user);
		const decimals = this.getDecimals();
		const clientName = originalOrder?.client?.name || (this.props.clients?.find(c => c.value == originalOrder?.client_id)?.label) || 'Cliente';

		return (
			<section className="dup-order-modal">
				{/* TOPBAR */}
				<header className="dup-topbar">
					<div className="dup-title-wrap">
						<div className="dup-iconbox">
							<i className="fa fa-clone"></i>
						</div>
						<div>
							<h1>Duplicar pedido</h1>
							<p className="dup-subtitle">Se creará una copia de este pedido. Puedes modificar los datos antes de guardarlo.</p>
						</div>
					</div>
					<button className="dup-close" aria-label="Cerrar" onClick={() => this.props.onClose(false)}>×</button>
				</header>

				{/* CONTENT */}
				<div className="dup-content">
					{/* LEFT COLUMN */}
					<main className="dup-left">
						{/* Pedido original */}
						<div className="dup-original">
							<div className="dup-iconbox">
								<i className="fa fa-square-o"></i>
							</div>
							<div>
								<strong>Pedido original</strong>
								<div className="dup-muted">
									ID: #{originalOrder?.correlative_number || originalOrder?.id} &nbsp;•&nbsp; Fecha: {originalOrder?.created_at ? moment(originalOrder.created_at).format('DD/MM/YYYY') : ''} &nbsp;•&nbsp; Cliente: {clientName}
								</div>
							</div>
						</div>

						{/* Resumen Subtotal y Total */}
						<div className="dup-summary">
							<div className="dup-sumrow">
								<span>SUBTOTAL:</span>
								<span>$ {Globals.formatMiles(Number(this.state.totals.original_subtotal_usd || this.getSubtotal() || 0).toFixed(decimals))}</span>
							</div>
							{(this.state.appliedDiscountsRules || []).filter(i => i.name !== 'Precio Especial').map((item, idx) => (
								<div className="dup-sumrow" key={`disc-rule-${idx}`}>
									<span>{item.name}:</span>
									<span style={{ color: '#e74c3c' }}>-$ {Globals.formatMiles(Number(item.totalAmount || 0).toFixed(decimals))}</span>
								</div>
							))}
							{this.state.form.show_taxes === Constants.ORDERS.SHOW_TAXES.YES && (
								<div className="dup-sumrow">
									<span>{this.state.countryEquivalent?.ivaAbbreviation || 'IVA'}:</span>
									<span>$ {Globals.formatMiles(Number(this.getIva() || 0).toFixed(decimals))}</span>
								</div>
							)}
							<div className="dup-sumrow">
								<span>TOTAL:</span>
								<span>$ {Globals.formatMiles(Number(this.getTotal() || 0).toFixed(decimals))}</span>
							</div>
						</div>

						{/* Estado de pago e Impuesto */}
						<div className="dup-payment-status">
							{can_include_taxes ? (
								<label className="dup-checkline">
									<input
										type="checkbox"
										checked={this.state.form.show_taxes === Constants.ORDERS.SHOW_TAXES.YES}
										onChange={() => this.checkedChange(!this.state.form.show_taxes)}
									/>
									Incluir Impuesto <span>ⓘ</span>
								</label>
							) : <div />}

							<button
								type="button"
								className={`dup-statusbtn ${this.state.form.status === Constants.PAYMENT_TYPES.PAID ? 'active' : ''}`}
								onClick={() => this.setPaymentType(Constants.PAYMENT_TYPES.PAID)}
							>
								💵 &nbsp; PAGADO
							</button>

							<button
								type="button"
								className={`dup-statusbtn ${this.state.form.status === Constants.PAYMENT_TYPES.TO_PAY ? 'active' : ''}`}
								onClick={() => this.setPaymentType(Constants.PAYMENT_TYPES.TO_PAY)}
							>
								▱ &nbsp; POR COBRAR
							</button>
						</div>

						{/* Sección Productos del pedido */}
						<div className="dup-section-head">
							<div className="dup-section-title">
								<span className="dup-mini"><i className="fa fa-th-large"></i></span>
								Productos del pedido
							</div>
							<button type="button" className="dup-primary" onClick={this.addProduct}>
								+ Agregar producto
							</button>
						</div>

						{/* Lista de productos scrollable */}
						<div className="dup-products-scroll">
							{(!order || !order.details || order.details.length === 0) ? (
								<div className="dup-no-items">No hay productos en el pedido</div>
							) : (
								order.details.map((item, index) => {
									const product = item.product || item;
									let label_total = '(' + item.quantity + ' × ' + Globals.formatMiles(item.selected_price || item.price, true) + ')';
									if (item.special_price_applied && item.special_price_limit > 0 && parseFloat(item.quantity) > parseFloat(item.special_price_limit)) {
										const specialQty = parseFloat(item.special_price_limit);
										const regularQty = parseFloat(item.quantity) - specialQty;
										label_total = '(' + specialQty + ' × ' + Globals.formatMiles(item.original_special_price, true) + ' + ' + regularQty + ' × ' + Globals.formatMiles(item.original_price, true) + ')';
									}
									let total = item.subtotal !== undefined
										? parseFloat(item.subtotal)
										: parse((item.selected_price || item.price || 0) * (item.quantity || 0), decimals);
									if (isNaN(total)) total = 0;

									if (item.discount != null && item.discount !== '') {
										let discountStr = String(item.discount);
										if (discountStr.includes('/') || discountStr.includes('+') || discountStr.includes('%')) {
											label_total += ' - ' + discountStr;
										} else {
											label_total += ' - ' + Globals.formatMiles(item.discount, true, '') + '%';
										}
									}

									let prices = product?.prices || [];
									const defaultPrice = product?.sale_price;
									const rawPrices = [];
									if (defaultPrice != null) rawPrices.push(parseFloat(defaultPrice));
									if (item.price != null) rawPrices.push(parseFloat(item.price));
									prices.forEach(p => rawPrices.push(parseFloat(p.price)));
									const uniquePrices = [...new Set(rawPrices.filter(p => !isNaN(p)))];
									const priceOptions = uniquePrices.map(p => ({
										value: p,
										label: Globals.formatMiles(p)
									}));

									return (
										<div className="dup-product-card" key={index}>
											<img
												className="dup-product-img"
												src={Globals.fromPhotos(product?.photo?.file)}
												alt={product?.name || 'Producto'}
												onError={e => { e.target.style.visibility = 'hidden'; }}
											/>
											<div>
												<div className="dup-pname">{product?.name}</div>
												<div className="dup-product-price-line">
													$ {Globals.formatMiles(Number(total || 0).toFixed(decimals))} {label_total}
												</div>
												{item.applied_discounts && item.applied_discounts.length > 0 && (
													<div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', margin: '4px 0' }}>
														{item.applied_discounts.map((rule, rIdx) => (
															<span
																key={rIdx}
																style={{
																	background: '#e8f5e9',
																	color: '#2e7d32',
																	fontSize: '11px',
																	padding: '2px 6px',
																	borderRadius: '4px',
																	fontWeight: '500'
																}}
															>
																🏷 {rule.name}: -{rule.percentage}%
															</span>
														))}
													</div>
												)}
												{item.special_price_applied && (
													<div style={{ margin: '2px 0' }}>
														<span
															style={{
																background: '#e3f2fd',
																color: '#1565c0',
																fontSize: '11px',
																padding: '2px 6px',
																borderRadius: '4px',
																fontWeight: '500'
															}}
														>
															🏷 Precio Especial {item.special_price_limit ? `(hasta ${item.special_price_limit} un.)` : ''}
														</span>
													</div>
												)}
												<div className="dup-product-fields">
													<div className="dup-field">
														<label>Precio</label>
														{priceOptions.length > 1 ? (
															<select
																value={parseFloat(item.special_price_applied && item.special_price_limit ? item.original_price : (item.selected_price || item.price))}
																onChange={e => this.changeValue(parseFloat(e.target.value), 'selected_price', index)}
															>
																{priceOptions.map((opt, i) => (
																	<option key={i} value={opt.value}>{opt.label}</option>
																))}
															</select>
														) : (
															<input
																type="number"
																step="0.01"
																value={(item.special_price_applied && item.special_price_limit ? item.original_price : (item.selected_price || item.price)) || ''}
																onChange={e => this.changeValue(parseFloat(e.target.value) || 0, 'selected_price', index)}
															/>
														)}
													</div>
													<div className="dup-field">
														<label>Descuento (%)</label>
														<input
															type="text"
															placeholder="0"
															value={item.discount?.toString() || ''}
															onChange={e => this.changeValue(e.target.value, 'discount', index)}
														/>
													</div>
												</div>
											</div>
											<div className="dup-qty-side">
												<button type="button" className="dup-qbtn" onClick={() => this.remove(index, product)}>−</button>
												<input
													className="dup-qty"
													type="number"
													value={item.quantity || 0}
													onChange={e => this.changeManual(index, e.target.value)}
												/>
												<button type="button" className="dup-qbtn" onClick={() => this.add(index, item)}>＋</button>
												<button
													type="button"
													className="dup-trash"
													onClick={() => this.delete(index)}
													title="Eliminar"
												>
													🗑
												</button>
											</div>
										</div>
									);
								})
							)}
						</div>

						{/* Nota informativa inferior */}
						<div className="dup-info-note">
							ⓘ &nbsp; Los datos de este pedido son una copia. El pedido original no será modificado.
						</div>
					</main>

					{/* RIGHT COLUMN */}
					<aside className="dup-right">
						<button
							type="button"
							className="dup-finish"
							onClick={this.submit}
							disabled={this.state.disabled_button}
						>
							FINALIZAR COMPRA
						</button>

						<div className="dup-right-section">
							<h2>
								<i className="fa fa-user"></i>
								&nbsp; Información del pedido
							</h2>

							{/* Vendedor */}
							<div className="dup-field">
								<label>Vendedor (Opcional)</label>
								<select
									value={this.state.seller?.id || this.state.seller?.value || this.state.order?.seller_id || ''}
									onChange={async e => {
										const val = e.target.value;
										if (!val) {
											await this.setState({ seller: null, orderModified: true });
											this.setTotals();
											return;
										}
										const s = (this.state.fullSellers || []).find(x => +x.id === +val) ||
											(this.props.sellers || []).find(x => +x.value === +val);
										await this.setState({ seller: s || null, orderModified: true });
										this.setTotals();
									}}
								>
									<option value="">Seleccione un vendedor</option>
									{(this.props.sellers || []).map(s => (
										<option key={s.value} value={s.value}>{s.label}</option>
									))}
								</select>
							</div>

							{/* Cliente */}
							<div className="dup-field">
								<label>Cliente *</label>
								<select
									value={this.state.form.client_id || ''}
									onChange={e => {
										const clientId = e.target.value;
										const foundClient = (this.props.clients || []).find(c => +c.value === +clientId) || null;
										this.setState({
											client: foundClient,
											form: { ...this.state.form, client_id: clientId }
										}, () => this.setTotals());
									}}
								>
									<option value="">Seleccione un cliente</option>
									{(this.props.clients || []).map(c => (
										<option key={c.value} value={c.value}>{c.label}</option>
									))}
								</select>
							</div>

							{/* Pago Inicial y Días de Crédito (si status es TO_PAY) */}
							{this.state.form.status == Constants.PAYMENT_TYPES.TO_PAY && (
								<div className="dup-two-cols">
									<div className="dup-field">
										<label>Pago Inicial (Opcional)</label>
										<input
											type="number"
											step="0.01"
											placeholder="0.00"
											value={this.state.form.initial_payment?.toString() || ''}
											onChange={e => {
												if (Globals.validateDouble(e.target.value) || e.target.value === '') {
													this.change(e.target.value, 'initial_payment');
												}
											}}
										/>
									</div>
									<div className="dup-field">
										<label>Días de crédito *</label>
										<input
											type="number"
											placeholder="Ej. 15"
											value={this.state.form.credit_days}
											onChange={e => {
												if (Globals.validateInteger(e.target.value) || e.target.value === '') {
													this.change(e.target.value, 'credit_days');
												}
											}}
										/>
									</div>
								</div>
							)}

							{/* Método de pago */}
							<div className="dup-field">
								<label>Método de pago</label>
								<select
									value=""
									onChange={e => {
										const val = e.target.value;
										if (val) this.addPaymentMethod(val);
									}}
								>
									<option value="">Seleccione uno o varios</option>
									{(this.props.methods || [])
										.filter(m => !this.state.methods_selected.some(ms => ms.id == m.value))
										.map(m => (
											<option key={m.value} value={m.value}>{m.label}</option>
										))}
								</select>
							</div>

							{/* Montos por método de pago */}
							{this.state.methods_selected.map((item, index) => {
								const methodName = item.name || (this.props.methods || []).find(m => m.value == item.id)?.label || 'Método';
								return (
									<div className="dup-amount-line" key={`method-sel-${index}`}>
										<strong title={methodName}>{methodName}</strong>
										<input
											type="number"
											step="0.01"
											min="0"
											placeholder="Monto"
											value={item.amount != null ? item.amount : ''}
											onChange={e => this.changeMethodAmount(e.target.value, index)}
										/>
										<button
											type="button"
											className="dup-trash"
											title="Quitar"
											onClick={() => this.removePaymentMethod(index)}
										>
											🗑
										</button>
									</div>
								);
							})}

							{/* Descuentos */}
							<div className="dup-two-cols">
								<div className="dup-field">
									<label>Descuento (%)</label>
									<input
										type="text"
										placeholder="Opcional"
										value={this.state.form.discount?.toString() || ''}
										onChange={async e => {
											let value = e.target.value.replace(/,/g, '.').replace(/[^0-9.]/g, '');
											if ((value.match(/\./g) || []).length > 1) {
												value = value.substring(0, value.length - 1);
											}
											if (Globals.validateDouble(value) || value === '') {
												await this.setState({ form: { ...this.state.form, discount: value } });
												this.setTotals();
											}
										}}
									/>
								</div>

								{(this.state.discountsRules || [])
									.filter(master => master.type === 'general' && master.status === 1)
									.map(discount => {
										const currentDiscount = this.state.form.general_discounts.find(d => d.discount_id === discount.id);
										const currentValue = currentDiscount ? currentDiscount.value : '';
										return (
											<div className="dup-field" key={`general-discount-input-${discount.id}`}>
												<label>{discount.name} (%)</label>
												<input
													type="text"
													placeholder="Opcional"
													value={currentValue}
													onChange={async e => {
														let value = e.target.value.replace(/,/g, '.').replace(/[^0-9.]/g, '');
														if ((value.match(/\./g) || []).length > 1) {
															value = value.substring(0, value.length - 1);
														}
														if (Globals.validateDouble(value) || value === '') {
															await this.changeGeneralDiscount(discount.id, value);
														}
													}}
												/>
											</div>
										);
									})}
							</div>

							{/* Badges informativos de descuentos automáticos aplicados */}
							{(() => {
								const appliedAutomaticDiscounts = [];
								if (this.state.form.general_discounts && this.state.discountsRules) {
									this.state.form.general_discounts.forEach(gd => {
										const ruleInfo = this.state.discountsRules.find(r => r.id === gd.discount_id);
										if (ruleInfo && ruleInfo.type !== 'general') {
											appliedAutomaticDiscounts.push({
												name: ruleInfo.name,
												percentage: gd.value,
												icon: 'fa-clock-o'
											});
										}
									});
								}
								if (order?.details) {
									order.details.forEach(item => {
										if (item.applied_discounts && item.applied_discounts.length > 0) {
											item.applied_discounts.forEach(ad => {
												const existing = appliedAutomaticDiscounts.find(d => d.name === ad.name && d.percentage === ad.percentage);
												if (!existing) {
													appliedAutomaticDiscounts.push({
														name: ad.name,
														percentage: ad.percentage,
														icon: 'fa-cube'
													});
												}
											});
										}
										if (item.special_price_applied) {
											const existing = appliedAutomaticDiscounts.find(d => d.name === 'Precio Especial');
											if (!existing) {
												appliedAutomaticDiscounts.push({ name: 'Precio Especial', percentage: 'Especial', icon: 'fa-tag' });
											}
										}
									});
								}
								return appliedAutomaticDiscounts.length > 0 ? (
									<div style={{ border: '2px solid #2874A6', borderRadius: '4px', padding: '10px', backgroundColor: '#eef2f7', width: '100%', margin: '8px 0' }}>
										<label style={{ color: '#00204a', display: 'block', fontSize: '13px', fontWeight: 'bold', marginBottom: '6px' }}>
											Descuentos aplicados automáticamente
										</label>
										<div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
											{appliedAutomaticDiscounts.map((ad, idx) => (
												<div key={`auto-discount-${idx}`} style={{ display: 'inline-flex', alignItems: 'center', backgroundColor: '#e2e9f3', color: '#333', padding: '4px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: '600', gap: '6px' }}>
													<i className={`fa ${ad.icon}`} style={{ color: '#6c757d' }}></i>
													<span>{ad.name}</span>
													{ad.percentage !== 'Especial' ? (
														<span style={{ backgroundColor: '#2874A6', color: '#fff', padding: '2px 6px', borderRadius: '4px', fontWeight: 'bold' }}>
															{ad.percentage}%
														</span>
													) : (
														<span style={{ backgroundColor: '#198754', color: '#fff', padding: '2px 6px', borderRadius: '4px', fontWeight: 'bold' }}>
															{ad.percentage}
														</span>
													)}
												</div>
											))}
										</div>
									</div>
								) : null;
							})()}



							{/* Comprobante de pago */}
							<div className="dup-field">
								<label>Comprobante de pago</label>
								<div
									className="dup-upload"
									onClick={() => document.getElementById('dup-upload-voucher').click()}
								>
									☁️ &nbsp; <strong>{this.state.form.file?.name || 'Subir comprobante (Opcional)'}</strong><br />
									<span className="dup-muted">JPG, PNG o PDF. Máx. 5MB</span>
								</div>
								<input
									id="dup-upload-voucher"
									type="file"
									accept="image/*,.pdf"
									style={{ display: 'none' }}
									onChange={e => this.change(e.target.files[0], 'file')}
								/>
							</div>

							{/* Información adicional */}
							<div className="dup-field">
								<label>Información adicional</label>
								<textarea
									placeholder="Agregar información adicional (Opcional)"
									value={this.state.form.information}
									onChange={e => this.change(e.target.value, 'information')}
								></textarea>
							</div>
						</div>
					</aside>
				</div>

				{/* Modal de Agregar Producto */}
				<Modal
					title="Seleccionar producto"
					onClose={() => this.onCloseProduct()}
					visible={visible_product}
				>
					<SelectProduct
						onSelect={this.onCloseProduct}
						onClose={() => this.onCloseProduct()}
						warehouses={this.state.warehouses}
						formatWarehouses={this.state.formatWarehouses}
					/>
				</Modal>
			</section>
		);
	}
}

const SelectProduct = ({ onSelect, onClose, warehouses, formatWarehouses }) => {
	const user = useSelector(state => state.user);
	const mainWarehouse = user.warehouse_id || user.warehouse_principal;
	const [products, setProducts] = useState([]);
	const [selected, setSelected] = useState([]);
	const [form, setForm] = useState({ warehouse_id: mainWarehouse, search: '' });

	const products_filter = products.map(product => {
		let totalStock = product.stock;

		if (product.size_colors) {
			product.size_colors = product.size_colors.filter(color => color.stock > 0);
			totalStock += product.size_colors.reduce((total, color) => total + color.stock, 0);
		}

		let matchSearch = true;
		if (form.search) {
			const search = form.search.toLowerCase();
			matchSearch = product?.name?.toLowerCase()?.includes(search) || product?.code?.toLowerCase()?.includes(search);
		}

		if (totalStock > 0 && matchSearch) {
			return product;
		} else {
			return null;
		}
	}).filter(Boolean);

	const select = (item) => {
		if (selected.includes(item.id)) {
			const others = selected.filter(x => x !== item.id);
			setSelected(others);
		} else {
			setSelected([...selected, item.id]);
		}
	};

	const onSelectWarehouse = async (warehouse_id) => {
		setForm({ ...form, warehouse_id: warehouse_id });

		Globals.setLoading();
		try {
			const res = await axios.post('web/admin/warehouses', {
				web: true,
				user_id: user.id,
				is_select: true,
				warehouse_id: warehouse_id,
				with_products: true,
				unique_by_size_color: true,
			});

			if (res.data && res.data.warehouses && res.data.warehouses.length > 0) {
				const selectedWarehouse = res.data.warehouses[0];

				if (selectedWarehouse && selectedWarehouse.products) {
					const productsList = selectedWarehouse.products.map(i => {
						const total_quantity = i.total_quantity;
						if (total_quantity <= 0) return null;
						return {
							...i.product,
							total_quantity: total_quantity
						};
					}).filter(product => product !== null);
					setProducts(productsList);
				} else {
					setProducts([]);
				}
			} else {
				setProducts([]);
			}
		} catch (error) {
			console.error('Error fetching warehouse products: ', error);
			Globals.showError('Error al cargar los productos del almacén');
		} finally {
			Globals.quitLoading();
		}
	};

	const submit = () => {
		onSelect(products.filter(x => selected.includes(x.id)).map(x => ({ ...x, warehouse_id: form.warehouse_id })));
		onClose();
	};

	useEffect(() => {
		onSelectWarehouse(mainWarehouse);
	}, []);

	const canSelectWarehouse = user.level_id == Constants.ROLE_ADMIN || (user.level_id == Constants.ROLE_MODERATOR && user.warehouse_id === null);

	return (
		<div id="container-create-edit-quote-select-product">
			{canSelectWarehouse && (
				<Select
					label="Almacén"
					className="material"
					labelClass="material"
					value={form.warehouse_id}
					options={formatWarehouses}
					onChange={e => onSelectWarehouse(parseInt(e.target.value))}
				/>
			)}

			<Input
				color=" "
				placeholder="Buscar por nombre"
				className="material"
				labelClass="material"
				onChange={e => setForm({ ...form, search: e.target.value })}
			/>

			{!!selected.length && (
				<div className="product-totals">
					<span>Seleccionados: {selected.length}</span>
					<button
						type="button"
						className="done"
						title="Agregar"
						onClick={() => submit()}
					>
						<Icon name="check" />
					</button>
				</div>
			)}

			{products_filter.map((item, index) => {
				const isSelected = selected.includes(item.id);
				return (
					<div
						key={`product-item-${index}`}
						className={`product-item ${isSelected ? 'selected' : ''}`}
						onClick={() => select(item)}
					>
						<div className="product-image">
							<img src={Globals.fromPhotos(item?.photo?.file)} alt="Producto" />
						</div>
						<div className="product-details">
							<span className="product-name" title={item?.name}>{item?.name}</span>
						</div>
						<div>${item?.sale_price}</div>
					</div>
				);
			})}
		</div>
	);
};

export default connect(state => {
	return {
		user: state.user,
		currency: state.currency,
	};
})(DuplicateOrder);
